// Returns the user's age in whole years from their birthday (YYYY-MM-DD).
// Null inputs return null.
export function computeAge(birthday) {
  if (!birthday) return null
  const bd = new Date(birthday)
  if (Number.isNaN(bd.getTime())) return null
  const today = new Date()
  let age = today.getFullYear() - bd.getFullYear()
  const monthDiff = today.getMonth() - bd.getMonth()
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < bd.getDate())) {
    age -= 1
  }
  return Math.max(0, age)
}

// Returns the number of whole days until the user's next birthday. Returns 0
// when today IS the birthday. Handles Feb 29 by treating it as Mar 1 in
// non-leap years.
export function daysUntilBirthday(birthday) {
  if (!birthday) return null
  const bd = new Date(birthday)
  if (Number.isNaN(bd.getTime())) return null

  const today = new Date()
  today.setHours(0, 0, 0, 0)

  const month = bd.getMonth()
  const day = bd.getDate()

  let next = new Date(today.getFullYear(), month, day)
  // Feb 29 in non-leap year — fall back to Mar 1
  if (next.getMonth() !== month) {
    next = new Date(today.getFullYear(), month + 1, 1)
  }

  if (next.getTime() < today.getTime()) {
    next = new Date(today.getFullYear() + 1, month, day)
    if (next.getMonth() !== month) {
      next = new Date(today.getFullYear() + 1, month + 1, 1)
    }
  }

  const diffMs = next.getTime() - today.getTime()
  return Math.round(diffMs / (1000 * 60 * 60 * 24))
}
